import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments';
import { Processor, Response } from '../../models';

@Injectable()
export class ProcessorService {

  private _processor: BehaviorSubject<Processor> = new BehaviorSubject<Processor>(null);

	constructor(private http: HttpClient) {
	}

	get processor$() {
	  return this._processor.asObservable();
  }

	getProcessor() {
		return this.http.get(environment.apiBaseUrl + '/processor2-get-processor')
			.pipe(
				shareReplay(1),
        tap((processorResponse: Response) => {
          this._processor.next(processorResponse.data);
        })
			);
	}

	updateProcessor(body) {
		return this.http.put(environment.apiBaseUrl + '/processor2-put-processor', body)
			.pipe(
				shareReplay(1)
			);
	}
}
